// extracted by mini-css-extract-plugin
module.exports = {"groups":"UpsellingItems_groups__3xpyH","label":"UpsellingItems_label__2VlEW"};